import React from 'react';

import ConnectionFailureView from 'pages/ConnectionFailure/ConnectionFailurePage';

import Footer from '../../components/footer';
import Header from '../../components/header/Header';

/**
 *Error boundaries are React components that catch JavaScript errors anywhere in their child 
 component tree, log those errors, and display a fallback UI instead of the component tree 
 that crashed. Error boundaries catch errors during rendering, in lifecycle methods, 
 and in constructors of the whole tree below them.

 More Info at: https://reactjs.org/docs/error-boundaries.html
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="fairstone-retail-oam-app" id="oam-app">
                    <Header />
                    <div className="fairstone-retail-oam-app-content">
                        <ConnectionFailureView />
                    </div>
                    <Footer />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
